import { WORKOUT_KEY } from '../../../../../modules/workout/model/constants/key'
import { isAuthorWorkoutUtil } from '../../../../../modules/workout/model/utils/is-author'

import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

function canEditWorkoutUtil (workout, profile) {
  return (
    isAuthorWorkoutUtil(workout, profile) ||
    isOwnedWorkoutUtil(workout, profile)
  )
}

function isOwnedWorkoutUtil (workout, profile) {
  return (
    getValueReduxUtil(workout, WORKOUT_KEY.PROFILE_ID) ===
    getIdReduxUtil(profile)
  )
}

export {
  canEditWorkoutUtil,
  isOwnedWorkoutUtil
}
